<template>
  <div>
    <div class="row my-4">
      <div class="col">
        <b-button variant="primary" v-show="quiz.questions.length < 10" @click="addQuestionBlock"><i class="fa fa-plus"></i> Ajouter une question</b-button>
      </div>

  </div>
  <div class="space_for_navbar"></div>
    <nav class="navbar navbar-dark fixed-bottom bg-dark justify-content-between  p-0">
      <div class="col-sm-3 col-md-2 mr-0">&nbsp;</div>

      <div class="col-sm-6 col-md-6 py-1 pull-right">
        <div class="pull-left">
          <span class="text-white" v-if="isSaving">
          <b-spinner small type="grow"></b-spinner>
            Saving...
          </span>
        </div>
        <div class="pull-right">
          <b-button variant="success" @click="action(true)" size="sm" class="mr-3">{{actionName}}</b-button>
          <b-button variant="success" @click="action(false)" size="sm" class="mr-3">{{actionName}} (return menu)</b-button>
          <b-button variant="danger" to="/administrator" size="sm">Cancel</b-button>
        </div>
      </div>

    </nav>
  </div>
</template>

<script>
  import { mapMutations, mapGetters } from 'vuex';
  import {
    RESET_QUIZ,
    ADD_QUESTION
  } from '@/store/quiz/mutations';
  export default {
    name: 'quiz-actions',
    props: ['action', 'actionName'],
    computed: {

      ...mapGetters('quiz',
        {
          quiz: 'newQuiz',
          isSaving: 'isSaving'
        }
      ),

      totalPoints() {
        // deprecated used to display the total number of points in admin
        return this.quiz.questions.reduce((curr, question) =>
          parseInt(question.points) + curr, 0);
        // we used parseInt because the value coming from the input is a string.
      }
    },
    methods: {
      ...mapMutations('quiz', {
        addQuestion: ADD_QUESTION,
        reset: RESET_QUIZ
      }),

      addQuestionBlock(questionIndex) {
        this.addQuestion();

        setTimeout( () =>
        {
          var options = {
            debug: 'info',
            modules: {
              toolbar: '#toolbar'+ (this.quiz.questions.length-1)
            },
            placeholder: 'Compose an epic...',
            readOnly: true,
            theme: 'snow'
          };
          var quill = new Quill('#question'+ (this.quiz.questions.length-1), options)
        }, 500);
      },
    }
  }
</script>


<style scoped>

/*
 * Navbar
 */

.space_for_navbar {
  height: 65px;
}

.navbar-left {
  padding-top: 1rem;
  padding-bottom: 1rem;
  font-size: 0.2rem;
  font-weight: strong;
  background-color: rgb(248, 249, 250);
  box-shadow: inset -1px 0 0 rgba(0, 0, 0, .1);
  height: auto;
}

.navbar.fixed-bottom {
    height: auto;
}

.bg-dark {
  background-color: #005e89!important;
}
.nav-link {
    cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/quiz/QuizActions.vue